
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-priority_high",
  "use": "icon-material-priority_high-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-priority_high\"><path d=\"M479.99-110.43q-31.14 0-53.32-22.23-22.17-22.23-22.17-53.45t22.3-53.27 53.44-22.05q31.15 0 53.2 22.22 22.06 22.23 22.06 53.45t-22.18 53.27q-22.18 22.06-53.33 22.06m-72.62-251v-486.94h145.26v486.94z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-priority_high"/>
                </svg>
            );
        };

        Icon.id = "icon-material-priority_high";

        export default Icon;
    